export const isExternalUrl = (url) => {
  const safeUrl = `${url}`.trim();

  if (safeUrl.startsWith('mailto:')) {
    return true;
  }

  return !!safeUrl.match(/(https?\:\/\/|www\.).+/i);
}
